import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

export const AccountRecoveryActions = {

  requestUserAccountRecovery: async (_, { login, email, strategy }) => {
    return axiosRequest.
      post('/users/request_account_recovery', { login, email, strategy }).
      catch(handleError)
  },

  verifyUserAccountRecoveryToken: async (_, token) => {
    return axiosRequest.
      post('/users/verify_account_recovery_token', { token }).
      catch(handleError)
  },

  recoverUserAccount: async (_, { token, password, passwordConfirmation }) => {
    return axiosRequest.
      post('/users/recover_account', { token, password, password_confirmation: passwordConfirmation }).
      catch(handleError)
  },

}
